import { render, staticRenderFns } from "./IconSvgGlobe.vue?vue&type=template&id=02bcfa82&scoped=true&"
import script from "./IconSvgGlobe.vue?vue&type=script&lang=js&"
export * from "./IconSvgGlobe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bcfa82",
  null
  
)

export default component.exports